import React, { useCallback, useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { pwaSettings } from 'configs/pwaConstants';
import LAOChartCard from './LAO_Common/LAOChartCard';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { chartsHeight as height } from 'helpers/styleHelpers';
import useSetQuery, { useMultiSetQuery } from 'customHooks/useQuery';

export const useStyles = makeStyles((theme) => ({
    rootClass: {
        height: "auto",
        minHeight: theme.spacing(25),
        borderRadius: theme.spacing(1),
        background: theme.palette.card.default,
    },
    titleClass: {
        marginRight: "auto",
        paddingBottom: theme.spacing(2),
        fontSize: theme.spacing(2),
        textTransform: "none",
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 0,
        }
    },
    sliderClass: {
        margin: `0px ${theme.spacing(2.25)}px ${theme.spacing(1)}px`,
        "& .slick-current": {
            display: "flex",
            justifyContent: "center"
        }
    },
    expand: {
        textTransform: "capitalize",
        textDecoration: 'none',
        border: 'none'
    },
    cardactions: {
        justifyContent: "center"
    },
}));

const LaoImportKpiWrapper = ({ defaultFilters }) => {

    const classes = useStyles({ height });
    const { t } = useTranslation();
    const [params] = useSetQuery();
    const setMultiParams = useMultiSetQuery();
    const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
    const [innerWidth, setInnerWidth] = useState(0);
    const [expanded, setExpanded] = useState(false);

    const getChartWidth = useCallback(() => {
        if (window.innerWidth >= 1650) return 1550; // 3charts in a row
        if (window.innerWidth >= 1120) return 1025; // 2 charts in a row
        // if (window.innerWidth >= 951) 
        return window.innerWidth * 0.85; // 85% width for screens between 951px and 1119px
        // return 500; // 1 chart in a row
    }, [innerWidth])

    const subTypeValues = {
        // Container Forcasting and Prediction
        "cntrWithGR": "IMPORT_CONTAINER_FORECAST_CNTR_WITH_GR",
        "cntrWithoutGR": "IMPORT_CONTAINER_FORECAST_CNTR_WITHOUT_GR",

        // PO Line items by shipment
        "PO_ITEMS_CT_WITHOUT_SHIPMENT": "IMPORT_KPI_PO_ITEMS_WITHOUT_SHIPMENT",
        "PO_ITEMS_CT_WITH_SHIPMENT": "IMPORT_KPI_PO_ITEMS_SHIPMENT",

        // Shipment Containers
        "IMPORT_KPI_SHIPMENT_CONTAINERS_TOTAL": "IMPORT_KPI_SHIPMENT_CONTAINERS",
        "IMPORT_KPI_SHIPMENT_CONTAINERS_WITH_IMPORT_DECLARATION": "IMPORT_KPI_SHIPMENT_CONTAINERS_ID",
        "IMPORT_KPI_SHIPMENT_CONTAINERS_WITHOUT_IMPORT_DECLARATION": "IMPORT_KPI_SHIPMENT_CONTAINERS_WITHOUT_ID",
        "IMPORT_KPI_SHIPMENT_CONTAINERS_KPI_DESTINATION": "IMPORT_KPI_SHIPMENT_CONTAINERS_WITHOUT_ID_AT_DEST",
        "IMPORT_KPI_SHIPMENT_CONTAINERS_PENDING_FOR_ARRIVAL": "IMPORT_KPI_SHIPMENT_CONTAINERS_WITHOUT_ID_PENDING",

        // Containers ready to Deliver
        "IMPORT_KPI_CONTAINER_RTD_CONTAINERS_WITH_IMPORT_DECLARATION": "IMPORT_KPI_SHIPMENT_CONTAINERS_ID",
        "IMPORT_KPI_CONTAINER_RTD_WITH_GR": "IMPORT_KPI_CONTAINER_RTD_WITH_GR",
        "IMPORT_KPI_CONTAINER_RTD_WITHOUT_GR": "IMPORT_KPI_CONTAINER_RTD_WITHOUT_GR",
        "IMPORT_KPI_CONTAINER_RTD_WITHOUT_GR_WITH_RDD": "IMPORT_KPI_CONTAINER_RTD_WITHOUT_GR_WITH_RD",
        "IMPORT_KPI_CONTAINER_RTD_WITHOUT_GR_WITHOUT_RDD": "IMPORT_KPI_CONTAINER_RTD_WITHOUT_GR_WITHOUT_RD",

        // Containers by Requested Delivery Date at Plant
        "IMPORT_KPI_CONTAINER_RDD": "IMPORT_KPI_CONTAINER_RDD",

        // PO Items by Deviation
        "IMPORT_KPI_PO_ITEMS_DEVIATION_PO_WITH_DEVIATION": "IMPORT_KPI_PO_ITEMS_DEVIATION",
        "IMPORT_KPI_PO_ITEMS_DEVIATION_PO_WITHOUT_DEVIATION": "IMPORT_KPI_PO_ITEMS_WITHOUT_DEVIATION",

        // Carrier Operations (top 10)
        "IMPORT_KPI_CARRIER_OP_CONTAINER_totalSpot": "IMPORT_KPI_CARRIER_OP_CONTAINER_SPOT",
        "IMPORT_KPI_CARRIER_OP_CONTAINER_totalBid": "IMPORT_KPI_CARRIER_OP_CONTAINER_BID",
        "IMPORT_KPI_CARRIER_OP_SHIPMENT_totalSpot": "IMPORT_KPI_CARRIER_OP_SHIPMENT_SPOT",
        "IMPORT_KPI_CARRIER_OP_SHIPMENT_totalBid": "IMPORT_KPI_CARRIER_OP_SHIPMENT_BID",

        // Contract Percentage
        "IMPORT_KPI_CARRIER_CONTRACT_CONTAINER_SPOT": "IMPORT_KPI_CARRIER_OP_CONTAINER_SPOT",
        "IMPORT_KPI_CARRIER_CONTRACT_CONTAINER_BID": "IMPORT_KPI_CARRIER_OP_CONTAINER_BID",
        "IMPORT_KPI_CARRIER_CONTRACT_SHIPMENT_SPOT": "IMPORT_KPI_CARRIER_OP_SHIPMENT_SPOT",
        "IMPORT_KPI_CARRIER_CONTRACT_SHIPMENT_BID": "IMPORT_KPI_CARRIER_OP_SHIPMENT_BID",
    }

    const setDetails = (filters = {}) => {
        const {
            // uncomment below lines to Remove importReqDateContAtPlantRange, importInternationalShipperWithSeparator filters 
            // importReqDateContAtPlantRange,
            // importInternationalShipperWithSeparator,
            ...prevFilters
        } = params.laoFilters

        setMultiParams({
            laoFilters: JSON.stringify({
                ...prevFilters,
                ...filters,
            }),
            isHyperlink: true
        });
    }

    // const tooltipEvent = ({ data }) => {
    //     return `${data.totalCount}`
    // }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    let resizeWindowInvoiceKPI = () => {
        setInnerWidth(window.innerWidth - window.innerWidth / 10 * 1.5);
    };

    useEffect(() => {
        resizeWindowInvoiceKPI();
        window.addEventListener("resize", resizeWindowInvoiceKPI);
        return () => window.removeEventListener("resize", resizeWindowInvoiceKPI);
    }, []);

    let chartsTop = [
        {
            title: t("forecast"),
            subtype: "IMPORT_CONTAINER_FORECAST",
            subtype1: "IMPORT_CONTAINER_FORECAST", // required when radio values change
            chart: "grouped",
            page: "importKPI",
            height: 400,
            minWidth: getChartWidth(),
            maxWidth: getChartWidth(),
            keys: ['cntrWithoutGR', 'cntrWithGR'],
            xKey: "formattedDate",
            xLabel: t('date'),
            showLegend: true,
            showBarLabel: !isMobile,
            showXAxisLabel: !isMobile,
            text1: "daily",
            text2: "weekly",
            text3: "monthly",
            radioKey: "daily",
            radioKey1: "weekly",
            radioKey2: "monthly",
            setDetailsData: true,
            setDetails: (data) => {
                const dateRange = { startTime: data?.startDate, endTime: data?.endDate };
                let filters = {}
                if (data?.key === "cntrWithGR") {
                    filters['goodsReceiptDateRange'] = dateRange;
                    filters['importEtaRangeBar'] = null;
                    filters['searchSubType'] = "IMPORT_CONTAINER_FORECAST";
                    filters['containerForecastBarType'] = "RECEIVED_CONTAINERS";
                } else {
                    filters['importEtaRangeBar'] = dateRange;
                    filters['goodsReceiptDateRange'] = null;
                    filters['searchSubType'] = "IMPORT_CONTAINER_FORECAST";
                    filters['containerForecastBarType'] = "IMPORT_CONTAINERS";
                }
                setDetails(filters); // table filter
            },
            barColors: 'set22',
            testId: "import-container-forecast-chart",
        }
    ];
    
    const chartsBottom = [
        {
            title: t("po_line_items_by_shipment"),
            subtype: "IMPORT_KPI_PO_ITEMS_SHIPMENT",
            chart: "trendline",
            colorPalette: "set13",
            displayKey: "stateDesc",
            tooltipKey: "stateDesc",
            // isHyperlinkTooltip: true, Uncomment when integrating Table
            colorBy: "xKey",
            showXAxisLabel: true,
            setDetails: (data) => {
                const filters = { searchSubType: subTypeValues[data?.stateKey] }
                setDetails(filters) // table filter
            },
            setDetailsData: true,
            testId: "po-items-by-shipment-chart",
            page: "importKPI",
            height: 400,
            minWidth: 500,
            maxWidth: 500,
            showTotal: true
        },
        {
            title: t("shipment_containers"),
            subtype: "IMPORT_KPI_SHIPMENT_CONTAINERS",
            chart: "text",
            tableContainer: t('total_containers'),
            title1: 'with_import_declaration',
            title2: 'without_import_declaration',
            title3: 'containers_without_import_declaration',
            title4: 'kpi_destination',
            title5: 'pending_for_arrival',
            displayKey: "stateDesc",
            tooltipKey: "stateDesc",
            setDetails: (data) => {
                const key = `${data?.valueType}_${data?.stateKey.toUpperCase()}`
                const filters = { searchSubType: subTypeValues[key] }
                setDetails(filters) // table filter
            },
            setDetailsData: true,
            testId: "shipment-table",
            page: "importKPI",
            height: 400,
            minWidth: 500,
            maxWidth: 500,
            showTotal: true
        },
        {
            title: t("containers_ready_to_deliver"),
            subtype: "IMPORT_KPI_CONTAINER_RTD",
            chart: "pie",
            height: 400,
            minWidth: 500,
            maxWidth: 500,
            colorPalette: "set15",
            // tooltipKey: "stateDesc",
            displayKey: "stateDesc",
            setDetails: (data) => {
                const key = `${data?.valueType}_${data?.stateKey.toUpperCase()}`
                const filters = { searchSubType: subTypeValues[key] }
                setDetails(filters) // table filter
            },
            setDetailsData: true,
            // tooltipEvent: tooltipEvent,
            testId: "container-ready-to-be-delivered-chart",
            page: "importKPI",
            text1: !isMobile ? "containers_with_import_declaration" : 'containers_with_import_declaration_mobile',
            text2: "with_GR",
            text3: "without_GR",
            stateKey1: "CONTAINERS_WITH_IMPORT_DECLARATION",
            stateKey2: "WITH_GR",
            stateKey3: "WITHOUT_GR",
            showTotal: true,
            customNoTextHeight: 3,
            isLegendClickable: false
        },
        {
            title: t("containers_by_requested_delivery_date_at_plant"),
            subtype: "IMPORT_KPI_CONTAINER_RDD",
            chart: "trendline",
            height: 400,
            maxWidth: 500,
            minWidth: 500,
            colorPalette: "set16",
            colorBy: "xKey",
            setDetails: (data) => {
                const filters = {
                    searchSubType: subTypeValues[data?.valueType],
                    importReqDateContAtPlantRange: { startTime: data?.startDate, endTime: data?.endDate }
                }
                setDetails(filters) // table filter
            },
            setDetailsData: true,
            showTotal: true,
            yLabel: '',
            showXAxisLabel: !isMobile,
            startDate: 'startDate',
            xKey: 'formattedStartDate',
            keys: ['totalCount'],
            yKey: 'totalCount',
            themeType: 'dark',
            page: "importKPI",
            testId: "containers-by-requested-delivery-date-at-plant-chart"
        },
        {
            title: t("po_items_by_deviation"),
            subtype: "IMPORT_KPI_PO_ITEMS_DEVIATION",
            chart: "pie",
            height: 400,
            minWidth: 500,
            maxWidth: 500,
            colorPalette: "set17",
            tooltipKey: "stateDesc",
            displayKey: "stateDesc",
            setDetails: (data) => {
                const key = `${data?.valueType}_${data?.stateKey.toUpperCase()}`
                setDetails({ searchSubType: subTypeValues[key] }) // table filter
            },
            setDetailsData: true,
            testId: "po_items_by_deviation-chart",
            page: "importKPI",
            text1: "po_item_with_deviation",
            text2: "po_item_without_deviation",
            text3: "po_with_deviation",
            stateKey1: "PO_WITH_DEVIATION",
            stateKey2: "PO_WITHOUT_DEVIATION",
            showTotal: true,
            donutChart: false,
            donutTitle: false,
            isLegendClickable: false
        },
        {
            title: t("carrier_operations"),
            subtype: "IMPORT_KPI_CARRIER_OP_CONTAINER",
            subtype1: "IMPORT_KPI_CARRIER_OP_SHIPMENT",
            chart: "trendline",
            height: 400,
            maxWidth: 500,
            minWidth: 500,
            colorPalette: "set19",
            colorBy: "yKey",
            showTotal: false,
            showXAxisLabel: !isMobile,
            setDetails: (data) => {
                const key = `${data?.valueType}_${data?.key}`;
                const filters = {
                    searchSubType: subTypeValues[key],
                    importInternationalShipperWithSeparator: data?.stateKey
                }
                setDetails(filters) // table filter
            },
            setDetailsData: true,
            xKey: 'stateDesc',
            yKey: 'totalCount',
            keys: ['totalBid', 'totalSpot'],
            themeType: 'dark',
            page: "importKPI",
            horizontal: true,
            text1: "import_kpi_container",
            text2: "import_kpi_shipment",
            radioKey: "container",
            radioKey1: "shipment",
            legend: true,
            legendData: [
                { stateDesc: t('bid') },
                { stateDesc: t('spot') }
            ],
            isLegendClickable: false,
            testId: "carrier_operations-chart",
        },
        {
            title: t("contract_percentage"),
            subtype: "IMPORT_KPI_CARRIER_CONTRACT_CONTAINER",
            subtype1: "IMPORT_KPI_CARRIER_CONTRACT_SHIPMENT",
            chart: "pie",
            height: 400,
            minWidth: 500,
            maxWidth: 500,
            colorPalette: "set18",
            setDetails: (data) => {
                const key = `${data?.valueType}_${data?.stateKey.toUpperCase()}`
                const filters = { searchSubType: subTypeValues[key] }
                setDetails(filters) // table filter
            },
            setDetailsData: true,
            testId: "radio_button_selection_type-chart",
            page: "importKPI",
            text1: "import_kpi_container",
            text2: "import_kpi_shipment",
            radioKey: "container1",
            radioKey1: "shipment1",
            showTotal: false,
            showSliceLabel: true,
            isLegendClickable: false
        }
    ]

    return (
        <Card className={classes.rootClass} data-testid="lao-import-kpis-wrapper">
            <CardHeader
                title={<Typography className={classes.titleClass} variant="h3" component={"h3"}>{t("live_status_text").toUpperCase()}</Typography>}
            />
            {
                isMobile && <>
                    <Slider {...pwaSettings} className={classes.sliderClass}>
                        {
                            [...chartsTop, ...chartsBottom].map(d => {
                                return (
                                    <div>
                                        <LAOChartCard {...d} maxWidth={innerWidth} minWidth={innerWidth} boxShadow="none" defaultFilters={defaultFilters} />
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </>
            }
            {
                !isMobile && <>
                    <CardContent p={0}>
                        <Grid
                            container
                            spacing={3}
                            alignItems="center"
                            justifyContent="center"
                        >
                            {
                                chartsTop.map(d => { 
                                    return (
                                        <Grid item p={1}>
                                            <LAOChartCard {...d} defaultFilters={defaultFilters} />
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </CardContent>
                    <Collapse in={expanded} timeout="auto">
                        <CardContent p={0} data-testid="expandable-content">
                            <Grid
                                container
                                spacing={3}
                                alignItems="center"
                                justifyContent="center"
                            >
                                {
                                    chartsBottom.map(d => { 
                                        return (
                                            <Grid item p={1}>
                                                <LAOChartCard {...d} defaultFilters={defaultFilters} />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </CardContent>
                    </Collapse>

                    <CardActions className={classes.cardactions}>
                        <Button
                            variant="outlined"
                            color="textSecondary"
                            className={classes.expand}
                            onClick={handleExpandClick}
                            disableRipple
                            data-testid="expand"
                            disableFocusRipple
                            endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        >
                            {expanded ? t('view_less') : t('view_more')}
                        </Button>
                    </CardActions>
                </>
            }
        </Card>
    );
}

export default LaoImportKpiWrapper